/**
 * Resolves the Chat API base URL based on the current environment.
 *
 * - Set REACT_APP_ENV=staging in Amplify Console for the staging branch
 * - Set REACT_APP_CHAT_API_URL_STAGING in Amplify Console for the staging branch
 * - Set REACT_APP_CHAT_API_URL in Amplify Console for the production branch
 */
const CHAT_API_URL =
  process.env.REACT_APP_ENV === 'staging'
    ? process.env.REACT_APP_CHAT_API_URL_STAGING || 'https://staging-api.leanfitt.com/api'
    : process.env.REACT_APP_CHAT_API_URL || 'https://api.leanfitt.com/api';

export default CHAT_API_URL;
